// Hooks (@tanstack/react-query) imports
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { PersonUpdate } from "./types";
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  data: PersonUpdate;
  notificationID: string | number;
}

export function useUpdatePersonMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  const queryClient = useQueryClient();

  async function updatePerson(params: paramsType): Promise<any> {
    const response = await api.put<any>("admin/persons", params.data);

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: updatePerson,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(["Person", variables.data.idCard]);
      onSuccessMutation?.(data, variables);
    },
    onError: onErrorMutation,
  });
}
